<template>
  <section class="hero">
    <img
      src="/img/6c6fa8-marmorlandschaft-bei-carrara-01.webp"
      alt="The marble landscape of the Apuan Alps above Carrara"
      class="hero__bg"
    />
    <div class="hero__veil"></div>

    <div class="hero__content">
      <div class="hero__label">Long-form portrait · 1947 — today</div>
      <h1 class="hero__title">
        <span class="hero__title-l1">Dominique</span>
        <span class="hero__title-l2">Stroobant</span>
      </h1>
      <p class="hero__tag">
        Belgian. Sculptor. Anarchist. Lives in a Tuscan quarry hamlet of 449 people. Profession on his passport: <em>Steenkapper</em>. Stonemason.
      </p>
      <div class="hero__hint">↓</div>
    </div>
  </section>
</template>

<style scoped>
.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: stretch;
  overflow: hidden;
  color: var(--paper);
}
.hero__bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.5) contrast(1.1) saturate(0.85);
  z-index: 0;
}
.hero__veil {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(27,27,31,0.35) 0%, rgba(27,27,31,0.15) 30%, rgba(27,27,31,0.55) 100%);
  z-index: 1;
}
.hero__content {
  position: relative;
  z-index: 2;
  margin: auto auto 6vh;
  padding: 0 var(--gutter);
  max-width: 1400px;
  width: 100%;
  display: grid;
  gap: 1.8rem;
}
.hero__label {
  font-family: var(--font-mono);
  font-size: clamp(0.78rem, 1.05vw, 1rem);
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--hero-eyebrow);
  font-weight: 400;
  /* The cursive title below has huge ascenders that overshoot its line-box
     upward — without this margin the eyebrow visually sticks to the title. */
  margin-bottom: clamp(2rem, 5vw, 4rem);
}
.hero__title {
  font-family: var(--font-cursive);
  font-weight: 900;
  font-style: italic;
  font-size: clamp(4.5rem, 14.5vw, 14rem);
  line-height: 0.62;
  letter-spacing: -0.01em;
  margin: 0;
  color: var(--paper);
  text-shadow: 0 4px 30px rgba(0,0,0,0.45);
  font-feature-settings: 'ss01' on;
}
.hero__title-l1, .hero__title-l2 { display: block; }
.hero__title-l2 {
  color: var(--accent-cursive);
}
.hero__tag {
  font-family: var(--font-body);
  font-size: clamp(1.1rem, 1.55vw, 1.5rem);
  font-weight: 400;
  line-height: 1.22;
  margin: 0;
  max-width: 36ch;
  color: var(--paper);
}
.hero__tag em { font-style: italic; color: var(--paper); font-weight: 400; }
.hero__hint {
  margin-top: 2rem;
  font-size: 1.6rem;
  color: var(--paper);
  opacity: 0.7;
  animation: nudge 2.2s var(--ease-out) infinite;
  width: 1em;
}
@keyframes nudge {
  0%, 100% { transform: translateY(0); opacity: 0.5; }
  50% { transform: translateY(8px); opacity: 1; }
}
</style>
